/* eslint-disable */
import { CognitoAuth, StorageHelper } from "amazon-cognito-auth-js";
import IndexRouter from "@/router/index";
import axios from "axios";
import store from "@/store/index";

const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;

const authData = {
  ClientId: CLIENT_ID,
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ["openid", "email", "com.maxar.ard/ard.search"],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID,
};

const auth = new CognitoAuth(authData);
auth.useCodeGrantFlow();

auth.userhandler = {
  onSuccess: function (result: any) {
    handleAuthSuccess();
  },

  onFailure: function (err: any) {
    store.commit("logout");
    IndexRouter.push({
      path: "/error",
      query: { message: "Login failed due to " + err },
    });
  },
};
const currUrl = window.location.href;
auth.parseCognitoWebResponse(currUrl);

function getUserInfo() {
  const USERINFO_URL = "https://" + auth.getAppWebDomain() + "/oauth2/userInfo";
  return axios.get(USERINFO_URL, createRequestData()).then((response) => {
    return response.data;
  });
}

function getSelfUser() {
  const SELF_URL = "https://" + process.env.VUE_APP_ARD_DOMAIN + "/auth/self";
  return axios.get(SELF_URL, createRequestData()).then((response) => {
    return response.data;
  });
}

function getAccountInfo(account_id: string) {
  const ACCOUNT_URL = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}`;
  return axios.get(ACCOUNT_URL).then((response) => {
    return response.data;
  });
}

function handleAuthSuccess() {
  return getSelfUser().then((self_response) => {
    getAccountInfo(self_response.user.account_id).then((account_response) => {
      store.commit("auth_success", {
        user: {},
        user_details: self_response.user,
        account_details: account_response.account,
        token: auth.getSignInUserSession().getAccessToken().jwtToken,
      });
    });
  });
}

function createRequestData() {
  const jwtToken = auth.getSignInUserSession().getAccessToken().jwtToken;
  return {
    headers: {
      Authorization: "Bearer " + jwtToken,
    },
  };
}

function getUserInfoStorageKey() {
  const keyPrefix = "CognitoIdentityServiceProvider." + auth.getClientId();
  const tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  const userInfoKey = keyPrefix + "." + tokenUserName + ".userInfo";
  return userInfoKey;
}

const storageHelper = new StorageHelper();
const storage = storageHelper.getStorage();

export default {
  auth: auth,

  login() {
    auth.getSession();
  },

  logout() {
    if (auth.isUserSignedIn()) {
      const userInfoKey = this.getUserInfoStorageKey();
      storage.removeItem(userInfoKey);
      auth.signOut();
    }
  },

  getUserInfoStorageKey,
  getUserInfo,
  handleAuthSuccess,
};
